var formValidation = {
	translate: function () {
		jQuery.extend(jQuery.validator.messages, {
			required: "Este campo &eacute; obrigatório.",
			remote: "Por favor, corrija este campo.",
			email: "",
			url: "Por favor, forne&ccedil;a uma URL v&aacute;lida.",
			date: "Por favor, forne&ccedil;a uma data v&aacute;lida.",
			dateISO: "Por favor, forne&ccedil;a uma data v&aacute;lida (ISO).",
			number: "Por favor, forne&ccedil;a um n&uacute;mero v&aacute;lido.",
			digits: "Por favor, forne&ccedil;a somente d&iacute;gitos.",
			creditcard: "Por favor, forne&ccedil;a um cart&atilde;o de cr&eacute;dito v&aacute;lido.",
			equalTo: "Por favor, forne&ccedil;a o mesmo valor novamente.",
			accept: "Por favor, forne&ccedil;a um valor com uma extens&atilde;o v&aacute;lida.",
			maxlength: jQuery.validator.format("Por favor, forne&ccedil;a n&atilde;o mais que {0} caracteres."),
			minlength: jQuery.validator.format("Por favor, forne&ccedil;a ao menos {0} caracteres."),
			rangelength: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1} caracteres de comprimento."),
			range: jQuery.validator.format("Por favor, forne&ccedil;a um valor entre {0} e {1}."),
			max: jQuery.validator.format("Por favor, forne&ccedil;a um valor menor ou igual a {0}."),
			min: jQuery.validator.format("Por favor, forne&ccedil;a um valor maior ou igual a {0}.")
		});
	},

	validation: function () {
		$('.validate').validate({
			errorClass: 'invalid',
			validClass: 'valid',
			errorElement: 'span'
		});
	},

	ready: function () {
		formValidation.translate();
		formValidation.validation();
	}
};

$(document).ready(formValidation.ready);